module.exports = __webpack_public_path__ + "img/st20.2f6fa112.png";